import { render, staticRenderFns } from "./RegisterContact.vue?vue&type=template&id=7ada8c6c&scoped=true"
import script from "./RegisterContact.vue?vue&type=script&lang=js"
export * from "./RegisterContact.vue?vue&type=script&lang=js"
import style0 from "./RegisterContact.vue?vue&type=style&index=0&id=7ada8c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ada8c6c",
  null
  
)

export default component.exports